var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPandora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 277.2 57",
    style: {
      enableBackground: "new 0 0 277.2 57"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:#00A0EE;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 277.2,
    height: 57
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M186.4,17.4c6.1,0,11.1,5,11.1,11.1c0,6.1-5,11.1-11.1,11.1c-6.1,0-11.1-5-11.1-11.1 C175.3,22.3,180.3,17.4,186.4,17.4 M186.4,10c-10.2,0-18.5,8.3-18.5,18.5c0,10.2,8.3,18.5,18.5,18.5c10.2,0,18.5-8.3,18.5-18.5 C204.9,18.2,196.6,10,186.4,10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.6,11.1v3c-3.2-2.6-7.3-4.2-11.7-4.2c-10.2,0-18.5,8.3-18.5,18.5c0,10.2,8.3,18.5,18.5,18.5 c4.4,0,8.5-1.6,11.7-4.2v3h6.8V11.1H71.6z M60.3,40c-6.4,0-11.5-5.2-11.5-11.5c0-6.4,5.2-11.5,11.5-11.5c6.4,0,11.5,5.2,11.5,11.5 C71.8,34.8,66.6,40,60.3,40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260.1,11.1v3c-3.2-2.6-7.3-4.2-11.7-4.2c-10.2,0-18.5,8.3-18.5,18.5c0,10.2,8.3,18.5,18.5,18.5 c4.4,0,8.5-1.6,11.7-4.2v3h6.8V11.1H260.1z M248.9,40c-6.4,0-11.5-5.2-11.5-11.5c0-6.4,5.2-11.5,11.5-11.5 c6.4,0,11.5,5.2,11.5,11.5C260.4,34.8,255.2,40,248.9,40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.1,13.3c-4,2.5-7.4,7-7.4,15v17.5h7.4V28.3c0-11.5,11.9-10.9,11.9-10.9V10v0 C228.9,10,222.5,9.8,217.1,13.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.6,13.7c-3.1-2.3-6.9-3.7-11.1-3.7c-4.2,0-8,1.4-11.1,3.7c-4.5,3.4-7.4,8.8-7.4,14.8v17.4h7.4v-2.6V28.5 c0-6.1,5-11.1,11.1-11.1c6.1,0,11.1,5,11.1,11.1v14.8v2.6h7.4V28.5C121,22.4,118.1,17,113.6,13.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.5,0c-1.9,0-3.4,1.5-3.4,3.4v10.7c-3.2-2.6-7.3-4.2-11.7-4.2c-10.2,0-18.5,8.3-18.5,18.5 c0,10.2,8.3,18.5,18.5,18.5c4.4,0,8.5-1.6,11.7-4.2v3h6.8V3.4V0H159.5z M144.8,40c-6.4,0-11.5-5.2-11.5-11.5 c0-6.4,5.2-11.5,11.5-11.5c6.4,0,11.5,5.2,11.5,11.5C156.4,34.8,151.2,40,144.8,40"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.5,10c-4.4,0-8.5,1.6-11.7,4.2v-3H0v42.4V57h3.4c1.9,0,3.4-1.5,3.4-3.4V42.8C10,45.4,14.1,47,18.5,47 C28.8,47,37,38.7,37,28.5C37,18.2,28.8,10,18.5,10 M18.1,40c-6.4,0-11.5-5.2-11.5-11.5c0-6.4,5.2-11.5,11.5-11.5 s11.5,5.2,11.5,11.5C29.6,34.8,24.5,40,18.1,40"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.8,11.1c-1.9,0-3.4-1.5-3.4-3.4c0-1.9,1.5-3.4,3.4-3.4c1.9,0,3.4,1.5,3.4,3.4 C277.2,9.6,275.7,11.1,273.8,11.1 M273.8,4.7c-1.7,0-3,1.3-3,3c0,1.6,1.3,3,3,3c1.7,0,3-1.4,3-3C276.8,6,275.4,4.7,273.8,4.7  M274.7,9.7l-1-1.5H273v1.5h-0.5V5.8h1.6c0.7,0,1.2,0.5,1.2,1.2c0,0.9-0.8,1.2-1,1.2l1,1.6H274.7z M274.1,6.2H273v1.5h1.1 c0.3,0,0.7-0.3,0.7-0.7C274.8,6.5,274.4,6.2,274.1,6.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandora);
export default __webpack_public_path__ + "static/media/pandora.85756ee96f6227a5309fad705711224d.svg";
export { ForwardRef as ReactComponent };